import Axios from 'axios';
import { protectedResources } from '../authConfig';

//const getAccessToken  = sessionStorage.getItem('AccessToken');
const URL =
  protectedResources.apiHRMobile.baseApi +
  '/api/v1/BackOffice/GetAdvanceSalaryRequests';
//const token           = getAccessToken;
let tokenKey;

export async function GetSalaryRequest(filter, limitNo = 'yes') {
  if (sessionStorage.getItem('AccessToken') !== null) {
    tokenKey = JSON.parse(sessionStorage.getItem('AccessToken')).value;
  }

  const config = {
    headers: { Authorization: `Bearer ${tokenKey}` },
  };

  let bodyParameters = {};
  if (limitNo === 'no') {
    bodyParameters = {
      year: filter.year,
      month: filter.month,
      offset: filter.offset,
      limit: 0,
      employeeId: filter.search,
      status: parseInt(filter.status) === 10 ? null : parseInt(filter.status),
    };
  } else {
    bodyParameters = {
      year: filter.year,
      month: filter.month,
      offset: filter.offset,
      limit: filter.perpage,
      employeeId: filter.search,
      status: parseInt(filter.status) === 10 ? null : parseInt(filter.status),
    };
  }

  //console.log(bodyParameters);

  try {
    const response = await Axios.post(URL, bodyParameters, config);
    return await response.data;
  } catch (error) {
   if (error?.response?.status == 401) {
      localStorage.removeItem("obj_user_info");
      sessionStorage.removeItem("AccessToken");
      throw new Error("Unauthorized");
    }
    
    
    throw error;
  }
}
